import { Skeleton } from 'antd';
import { Tag, Spacing } from '@bluevision/components';
import { useTranslation } from 'react-i18next';

interface IdentificationStatusProps {
  loading: boolean;
  /** 认证状态 */
  isVerified: boolean;
  /** 认证   实名认证/企业认证 */
  authenticationName: string;
}

const IdentificationStatus: React.FC<IdentificationStatusProps> = (props) => {
  const { loading, isVerified, authenticationName } = props;

  const { t } = useTranslation();

  return loading ? (
    <Skeleton.Button size='small' active />
  ) : (
    <Spacing>
      {authenticationName}
      <Tag color={isVerified ? 'green' : 'gray'}>
        {isVerified ? t('certified') : t('uncertified')}
      </Tag>
    </Spacing>
  );
};

export default IdentificationStatus;
